<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar-xl">
                  <div>
                      <h4 class="text-primary">Sale Monitoring</h4>
                      <hr>
                      <div class="row">
                        <div class="col-md-4">
                          <dl class="row">
                            <dt class="col-md-4">Company</dt>
                            <dd class="col-md-8">
                              <select v-model="company_no" class="form-control">
                                <option value="">-- All --</option>
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-4">Salesman</dt>
                            <dd class="col-md-8">
                              <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="salesman_id" class="vsc-custom vsc-custom-inline"/>
                            </dd>
                            <dt class="col-md-4">&nbsp;</dt>
                            <dd class="col-md-8">
                              <button type="button" class="btn btn-sm pull-left btn-hard-primary waves-light waves-effect" @click="refreshList"><i class="fa fa-refresh" aria-hidden="true"></i> Refresh</button>
                              <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
                              <div class="dropdown-menu" aria-labelledby="print">
                                <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                              </div>
                            </dd>
                          </dl>
                        </div>
                        <div class="col-md-4">
                          <dl class="row">
                            <dt class="col-md-4">Date</dt>
                            <dd class="col-md-8">
                              <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                            </dd>
                            <dt class="col-md-4">Area</dt>
                            <dd class="col-md-8">
                              <select v-model="area" class="form-control">
                                <option value="">-- All --</option>
                                <option v-for="a in areaList" :key="a.id" :value="a.name">{{ a.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-4">Customer</dt>
                            <dd class="col-md-8">
                              <v-select :options="getCustomer" :reduce="customer => customer.meta.code" label="customer" v-model="customer" class="vsc-custom vsc-custom-inline"/>
                              {{ customer }}
                            </dd>
                            <dt class="col-md-4">Product Category</dt>
                            <dd class="col-md-8">
                              <select v-model="product_category" class="form-control">
                                <option value="">-- All --</option>
                                <option v-for="(c, idx) in productCategoryList" :key="idx" :value="c.id">{{ c.name }} [{{ c.id }}]</option>
                              </select>
                            </dd>
                          </dl>
                        </div>
                        <div class="col-md-4">
                        </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="row" style="margin-top: 250px">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Product</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalCountProduct | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Sales</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalSales | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Discount</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalDiscount | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total Tax</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalTax | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
              <div class="card">
                  <div class="card-body">
                      <div class="table-responsive">
                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                              <thead>
                                <th>No</th>
                                <th>Sale No.</th>
                                <th>Sale Date</th>
                                <th>Customer</th>
                                <th>Area</th>
                                <th class="text-center">Salesman</th>
                                <th>Product</th>
                                <th>Category</th>
                                <th class="text-center">Qty</th>
                                <th class="text-center">Uom</th>
                                <th class="text-right">Price</th>
                                <th class="text-right">Discount</th>
                                <th class="text-right">DPP</th>
                                <th class="text-right">Tax</th>
                                <th class="text-right">Total Tax</th>
                                <th class="text-right">Total</th>
                              </thead>
                              <tbody>
                                  <tr v-for="i in filterData" :key="i.id">
                                      <td>{{ i.no | currency }}</td>
                                      <td>
                                        <span class="text-ref-sales" @click="showSaleNo(i.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ i.sale_no }}</span>
                                      </td>
                                      <td>{{ i.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ i.customer }}</td>
                                      <td>{{ i.area }}</td>
                                      <td class="text-center">
                                        <span v-if="i.salesman_id">{{ i.salesman }}</span>
                                      </td>
                                      <td><b>[{{ i.product_no}}]</b> {{ i.product }}</td>
                                      <td>{{ i.product_category }}</td>
                                      <td class="text-center">{{ i.qty }}</td>
                                      <td class="text-center">{{ i.uom_id }}</td>
                                      <td class="text-right">{{ i.price | currency }}</td>
                                      <td class="text-right">{{ i.discount | currency }}</td>
                                      <td class="text-right">{{ i.subtotal | currency }}</td>
                                      <td class="text-right">{{ i.tax | currency }}</td>
                                      <td class="text-right">{{ i.total_tax | currency }}</td>
                                      <td class="text-right">{{ i.total | currency }}</td>
                                  </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td class="text-right"><b>{{ totalSubtotal | currency }}</b></td>
                                  <td class="text-right"><b>{{ totalTax | currency }}</b></td>
                                  <td class="text-right"><b>{{ totalSales | currency }}</b></td>
                                </tr>
                              </tfoot>
                          </table>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <SaleModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { productUrl, reportUrl, getHeader, sale2Url } from '@/config'
import DatePicker from 'vue2-datepicker'
import SaleModal from '@/components/sales/SaleModal.vue'

export default {
  name: 'SaleMonitoring',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    SaleModal
  },
  data () {
    var date = new Date()
    return {
      customer: '',
      loadingSales: true,
      area: '',
      product_category: '',
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
    this.$store.dispatch('getAreaList')
    this.$store.dispatch('getCustomerListLite')
    this.$store.dispatch('getProductCategoryList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      areaList: state => state.area.areaList,
      customerList: state => state.customers.customerListLite,
      productCategoryList: state => state.products.productCategoryList
    }),
    totalSubtotal () {
      var sum = 0
      const array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += (parseFloat(array[i].qty) * parseFloat(array[i].subtotal))
      }
      return sum
    },
    totalCountProduct () {
      var count = 0
      const array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        count += 1
      }
      return count
    },
    totalDiscount () {
      var sum = 0
      const array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].discount)
      }
      return sum
    },
    totalTax () {
      var sum = 0
      const array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_tax)
      }
      return sum
    },
    totalSales () {
      var sum = 0
      const array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    getCustomer () {
      var array = this.customerList
      var loop = [{
        customer: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          customer: array[a].name,
          meta: {
            code: array[a].customer_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    }
  },
  methods: {
    async recalculateSaldo () {
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product_no: array[i].product_no,
          date: null
        }
        await axios.post(productUrl + '/cost/get-saldo', obj, { headers: getHeader() })
          .then(response => {
            array[i].saldo = response.data.data.qty
            array[i].saldo_uom_id = response.data.data.uom_id
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            array[i].saldo = 0
            array[i].saldo_uom_id = ''
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no,
        salesman: this.salesman_id,
        area: this.area,
        customer_no: this.customer,
        product_category: this.product_category
      }
      console.log(obj)
      await axios.post(reportUrl + '/sale-monitoring', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        format: type,
        data: this.dataRaw,
        begin: begin,
        end: end
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(sale2Url + '/sale-monitoring', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
